import { types } from 'mobx-state-tree'

import { Auth } from './'

export const AuthRoot = types.model('AuthRoot', {
  auth: types.optional(Auth, {}),
})
